<form autocomplete="off" [name]="formName" [id]="formName" [formGroup]="formControl"
    (ngSubmit)="handleFormSubmit($event)">

    <!-- <shared-forms-input [compact]="compact" [parentForm]="formControl" name="cellNumber" [label]="labelMobilePhone"
        type="text" pattern="[0-9]*" inputmode="numeric" (onButtonClick)="handleErrorButtonClick($event)">
    </shared-forms-input> -->
    <shared-forms-phone-input [placeholder]="placeholderMobilePhone" [parentForm]="formControl" [compact]="compact"
        [label]="labelMobilePhone" [compact]="compact" [defaultSelected]="countryId"
        (onButtonClick)="handleErrorButtonClick($event)">
    </shared-forms-phone-input>

    <shared-forms-input [errors]="signInError$ | async" [compact]="compact" [parentForm]="formControl" type="password"
        name="password" [label]="labelPassword">
    </shared-forms-input>

    <ng-template #left>
        <shared-link [emphasis]="emphasis" (onClick)="handleForgotPasswordClick($event)">Forgot your password?
        </shared-link>
    </ng-template>

    <ng-template #right>
        <shared-forms-submit [loading]="loading$ | async" marginTop="none" width="normal" [parentForm]="formControl">
            Sign in
        </shared-forms-submit>
    </ng-template>

    <shared-forms-offset-wrapper [topOffset]="modal" [modalOffset]="modal" [left]="left" [right]="right">
    </shared-forms-offset-wrapper>


</form>